import React, { useState } from "react";
import {
  Card,
  CardContent,
  Container,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useNavigate, useParams } from "react-router-dom";
import { groupAPI } from "../../services/api";

const GroupInvitePage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const groupId = new URLSearchParams(window.location.search).get("groupId");
  const [status, setStatus] = useState<"idle" | "loading" | "done" | "error">(
    "idle"
  );
  const [message, setMessage] = useState<string | null>(null);

  console.log("Loaded group invite page", { token, groupId });

  const handleDecision = async (action: "accept" | "decline") => {
    if (!token) {
      setMessage("Invalid invitation link.");
      setStatus("error");
      return;
    }

    try {
      setStatus("loading");
      console.log("Submitting invitation decision", {
        action,
        token,
        groupId,
      });
      if (action === "accept") {
        await groupAPI.invitations.accept(token);
        setMessage("Invitation accepted.");
      } else {
        await groupAPI.invitations.decline(token);
        setMessage("Invitation declined.");
      }
      setStatus("done");
      navigate("/groups");
    } catch (error) {
      setStatus("error");
      setMessage("Unable to process invitation.");
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Card elevation={0} sx={{ borderRadius: 3, border: "1px solid" }}>
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h5" fontWeight={700}>
              Group invitation
            </Typography>
            <Typography color="text.secondary">
              Review and respond to this invitation.
            </Typography>
            {message && (
              <Typography color="text.secondary">{message}</Typography>
            )}
            <Stack direction="row" spacing={1.5}>
              <Tooltip title="Accept invitation">
                <span>
                  <IconButton
                    color="success"
                    disabled={status === "loading"}
                    onClick={() => {
                      console.log("Accepting invite from invite page", {
                        token,
                      });
                      handleDecision("accept");
                    }}
                  >
                    <CheckCircleIcon />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title="Decline invitation">
                <span>
                  <IconButton
                    color="error"
                    disabled={status === "loading"}
                    onClick={() => {
                      console.log("Declining invite from invite page", {
                        token,
                      });
                      handleDecision("decline");
                    }}
                  >
                    <CancelIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
};

export default GroupInvitePage;
